const communityFeatures = [
  {
    icon: 'ri-radio-line',
    title: 'Seguir Radios',
    description: 'Seguí tus estaciones favoritas y recibí contenido exclusivo, alertas de transmisiones en vivo y acceso prioritario a eventos.',
    tag: 'Social',
  },
  {
    icon: 'ri-calendar-check-line',
    title: 'Seguir Programas',
    description: 'No te pierdas ningún episodio. Activá recordatorios, participá en encuestas en vivo y comentá con la comunidad durante la emisión.',
    tag: 'Interacción',
  },
  {
    icon: 'ri-mic-line',
    title: 'Seguir Locutores',
    description: 'Conectá directamente con las voces detrás del micrófono. Recibí sus publicaciones, historias y contenido detrás de cámaras.',
    tag: 'Conexión',
  },
  {
    icon: 'ri-notification-3-line',
    title: 'Notificaciones',
    description: 'Enterate al instante cuando tu programa favorito empieza, tu locutor publica algo nuevo o hay un evento en tu radio.',
    tag: 'Tiempo real',
  },
  {
    icon: 'ri-chat-3-line',
    title: 'Chat en Vivo',
    description: 'Conversá con locutores y oyentes durante las transmisiones. Mandá mensajes, reaccioná y sé parte de la conversación.',
    tag: 'Comunidad',
  },
  {
    icon: 'ri-heart-3-line',
    title: 'Saludos',
    description: 'Enviá saludos al aire, dedicatorias y mensajes que los locutores leen en vivo. Tu voz también suena en la radio.',
    tag: 'Participación',
  },
  {
    icon: 'ri-music-line',
    title: 'Canciones',
    description: 'Pedí temas, votá en rankings musicales y descubrí nueva música recomendada por locutores y otros oyentes de la comunidad.',
    tag: 'Música',
  },
];

export default function ComunidadSection() {
  return (
    <section id="comunidad" className="relative py-20 md:py-28 overflow-hidden bg-background-50">
      {/* Subtle ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-accent-500/3 rounded-full blur-3xl pointer-events-none"></div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 max-w-7xl mx-auto">
        {/* ── Header ── */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-50 border border-accent-200 text-accent-700 text-xs font-semibold mb-5">
            <i className="ri-group-line text-xs"></i>
            Más que un directorio
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 tracking-tight leading-[1.1]">
            Escuchá · Compartí ·{' '}
            <span className="text-accent-600">Conectá</span>
          </h2>
          <p className="mt-4 text-foreground-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            RFW es la red social de la radio. Seguí a tus radios, locutores y programas favoritos. Interactuá en tiempo real con la comunidad.
          </p>
        </div>

        {/* ── Feature cards grid ── */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {communityFeatures.slice(0, 4).map((feature) => (
            <div
              key={feature.title}
              className="group relative rounded-2xl border border-background-200/70 bg-background-50 p-6 md:p-7 transition-all duration-300 hover:-translate-y-1 hover:border-accent-200 hover:shadow-lg hover:shadow-accent-500/5"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-50 text-accent-600 mb-4 transition-all duration-300 group-hover:bg-accent-500 group-hover:text-background-50">
                <i className={`${feature.icon} text-lg`}></i>
              </div>
              <div className="flex items-center gap-2 mb-2">
                <h3 className="text-foreground-950 font-bold text-sm md:text-base">{feature.title}</h3>
                <span className="text-[10px] font-semibold text-accent-600 bg-accent-50 px-2 py-0.5 rounded-full whitespace-nowrap">{feature.tag}</span>
              </div>
              <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* ── Second row: 3 cards centered ── */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5 max-w-3xl mx-auto">
          {communityFeatures.slice(4, 7).map((feature) => (
            <div
              key={feature.title}
              className="group relative rounded-2xl border border-background-200/70 bg-background-50 p-6 md:p-7 transition-all duration-300 hover:-translate-y-1 hover:border-accent-200 hover:shadow-lg hover:shadow-accent-500/5"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-50 text-accent-600 mb-4 transition-all duration-300 group-hover:bg-accent-500 group-hover:text-background-50">
                <i className={`${feature.icon} text-lg`}></i>
              </div>
              <div className="flex items-center gap-2 mb-2">
                <h3 className="text-foreground-950 font-bold text-sm md:text-base">{feature.title}</h3>
                <span className="text-[10px] font-semibold text-accent-600 bg-accent-50 px-2 py-0.5 rounded-full whitespace-nowrap">{feature.tag}</span>
              </div>
              <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* ── Bottom visual line ── */}
        <div className="mt-14 flex items-center justify-center gap-3">
          <div className="h-px flex-1 max-w-[120px] bg-gradient-to-r from-transparent to-accent-300"></div>
          <div className="w-2 h-2 rounded-full bg-accent-400"></div>
          <span className="text-foreground-400 text-xs font-medium whitespace-nowrap">Todo conectado en un solo lugar</span>
          <div className="w-2 h-2 rounded-full bg-accent-400"></div>
          <div className="h-px flex-1 max-w-[120px] bg-gradient-to-l from-transparent to-accent-300"></div>
        </div>
      </div>
    </section>
  );
}